function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.91914 12.9313H3.54658C3.24488 12.9313 3 13.1762 3 13.4779V22.2229C3 22.5246 3.24488 22.7695 3.54658 22.7695H7.91909C8.2208 22.7695 8.46567 22.5246 8.46567 22.2229V13.4779C8.46567 13.1762 8.22085 12.9313 7.91914 12.9313Z",
  fill: "#403E3D"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.4777 7.46558H10.1052C9.80347 7.46558 9.55859 7.71045 9.55859 8.01216V22.2228C9.55859 22.5245 9.80347 22.7694 10.1052 22.7694H14.4777C14.7794 22.7694 15.0243 22.5245 15.0243 22.2228V8.01216C15.0242 7.71045 14.7794 7.46558 14.4777 7.46558Z",
  fill: "#403E3D"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M21.0363 2H16.6638C16.3621 2 16.1172 2.24488 16.1172 2.54658V22.2229C16.1172 22.5247 16.3621 22.7695 16.6638 22.7695H21.0363C21.338 22.7695 21.5829 22.5247 21.5829 22.2229V2.54658C21.5828 2.24483 21.338 2 21.0363 2Z",
  fill: "#403E3D"
});

var SvgOffline = function SvgOffline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOffline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/offline.31d9a62f.svg";
export { ForwardRef as ReactComponent };